import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import type { ChainWeightingMode } from '~/types/services/priceParrot';

import { chainParityQueryKeys } from './chainParityQueryKeys';

export function useGetChainParityProperties(
  chainName: string | undefined,
  dateFrom: string | undefined,
  dateTo: string | undefined,
  limit: number,
  continent: string | null,
  weighting: ChainWeightingMode,
) {
  return useQuery({
    queryKey: chainParityQueryKeys.properties(
      chainName ?? '',
      dateFrom ?? '',
      dateTo ?? '',
      limit,
      continent ?? null,
      weighting,
    ),
    queryFn: async ({ signal }) => {
      if (!chainName || !dateFrom || !dateTo) {
        throw new Error('Chain parity properties requires chainName, dateFrom, and dateTo');
      }
      const res = await PriceParrotService.getParityTrendChainProperties(
        chainName,
        {
          date_from: dateFrom,
          date_to: dateTo,
          limit,
          continent: continent || undefined,
          weighting,
        },
        signal,
      );
      return res.data;
    },
    enabled: Boolean(chainName && dateFrom && dateTo),
  });
}
